export const formatSettlementPaymentCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  const numericValue = Number(value);

  return Number.isNaN(numericValue)
    ? value
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(numericValue);
};

export const formatSettlementPaymentDate = (value) => {
  if (!value) {
    return "N/A";
  }

  return new Date(value).toLocaleDateString("en-US", { timeZone: "UTC" });
};
